"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICON_SIZE = exports.TICKET_ORIGIN_CHOICES = exports.FRESHDESK_TICKET_ORIGIN = exports.CALL_CENTER_TICKET_ORIGIN = exports.SUPPORT_CREATE_TICKET_FIELDS = exports.TICKET_FIELDS = exports.REQUIRED_FIELDS = exports.TICKET_ASSIGNED_OFFICER_KEYS = exports.TICKET_DESCRIPTION_KEYS = exports.TICKET_SUMMARY_KEYS = exports.TICKET_SUBJECT = exports.OFFICER_TYPES_CHOICES = exports.PRODUCT_CHOICES = exports.PRIORITY_CHOICES = exports.TICKET_SOURCE_CHOICES = exports.TICKET_CLUSTER_CHOICES = exports.TICKET_TYPE_CHOICES = exports.ASSIGNED_TEAM_CHOICES = exports.STATUS_CHOICES = exports.COMMENTS_DETAIL_OR_UPDATE_URL = exports.COMMENTS_CREATE_OR_LIST_URL = exports.TICKET_DETAIL_OR_UPDATE_URL = exports.TICKET_STATUS_COLORS = exports.TICKET_PRIORITY_COLORS = exports.SAVINGS = exports.QC = exports.JUMIA = exports.URGENT = exports.HIGH = exports.MEDIUM = exports.LOW = exports.CLOSED = exports.RESOLVED = exports.PENDING = exports.OPEN = exports.PRODUCT_LMS = exports.PRODUCT_MICRO_LOANS = exports.RISK = exports.CREDIT_COLLECTIONS = exports.SUPPORT = exports.ACCOUNTING = exports.UPDATE_TAB = exports.DETAIL_TAB = exports.LIST_TAB = exports.CREATE_TAB = exports.initialFilterParams = void 0;
const typesConstants_1 = require("../../constants/typesConstants");
const constants_1 = require("../../constants/constants");
const colors_1 = __importDefault(require("../../styles/colors"));
exports.initialFilterParams = {
    id: undefined,
    customer_id: undefined,
    priority: undefined,
    assigned_team: undefined,
    status: undefined,
    ticket_date: undefined,
};
exports.CREATE_TAB = 'create';
exports.LIST_TAB = 'list';
exports.DETAIL_TAB = 'detail';
exports.UPDATE_TAB = 'update';
exports.ACCOUNTING = 0;
exports.SUPPORT = 1;
exports.CREDIT_COLLECTIONS = 2;
exports.RISK = 3;
exports.PRODUCT_MICRO_LOANS = 4;
exports.PRODUCT_LMS = 5;
exports.OPEN = 2;
exports.PENDING = 3;
exports.RESOLVED = 4;
exports.CLOSED = 5;
exports.LOW = 1;
exports.MEDIUM = 2;
exports.HIGH = 3;
exports.URGENT = 4;
exports.JUMIA = 0;
exports.QC = 1;
exports.SAVINGS = 2;
exports.TICKET_PRIORITY_COLORS = {
    [exports.LOW]: colors_1.default.YELLOW,
    [exports.MEDIUM]: colors_1.default.BLUE,
    [exports.HIGH]: colors_1.default.FONT_RED,
    [exports.URGENT]: colors_1.default.RED,
};
exports.TICKET_STATUS_COLORS = {
    [exports.OPEN]: colors_1.default.YELLOW,
    [exports.PENDING]: colors_1.default.BLUE,
    [exports.RESOLVED]: colors_1.default.GREEN,
    [exports.CLOSED]: colors_1.default.RED,
};
exports.TICKET_DETAIL_OR_UPDATE_URL = `support/tickets/${constants_1.TICKET_ID}/`;
exports.COMMENTS_CREATE_OR_LIST_URL = `support/tickets/${constants_1.TICKET_ID}/comments/`;
exports.COMMENTS_DETAIL_OR_UPDATE_URL = `support/tickets/${constants_1.TICKET_ID}/comments/${constants_1.COMMENT_ID}/`;
const EMAIL = 1;
const PORTAL = 2;
const PHONE = 3;
const FORUM = 4;
const TWITTER = 5;
const FACEBOOK = 6;
const CHAT = 7;
const MOBIHELP = 8;
const FEEDBACK_WIDGET = 9;
const OUTBOUND_EMAIL = 10;
const ECOMMERCE = 11;
const BOT = 12;
const WHATSAPP = 13;
const CLUSTER_0 = 0;
const CLUSTER_1 = 1;
const CLUSTER_2 = 2;
const CLUSTER_3 = 3;
const CLUSTER_4 = 4;
const COMPLAINT = 1;
const OTHERS = 2;
const REQUEST = 3;
const ENQUIRY = 4;
const MBS = 5;
exports.STATUS_CHOICES = [
    { value: '', label: 'Please select a status' },
    { value: exports.OPEN, label: 'Open' },
    { value: exports.PENDING, label: 'Pending' },
    { value: exports.RESOLVED, label: 'Resolved' },
    { value: exports.CLOSED, label: 'Closed' },
];
exports.ASSIGNED_TEAM_CHOICES = [
    { value: '', label: 'Please select a team' },
    { value: exports.ACCOUNTING, label: 'Accounting' },
    { value: exports.SUPPORT, label: 'Support' },
    { value: exports.CREDIT_COLLECTIONS, label: 'Credit collections' },
    { value: exports.RISK, label: 'Risk' },
    { value: exports.PRODUCT_MICRO_LOANS, label: 'Product - Micro Loans' },
    { value: exports.PRODUCT_LMS, label: 'Product - LMS' },
];
exports.TICKET_TYPE_CHOICES = [
    { value: '', label: 'Please select ticket type' },
    { value: COMPLAINT, label: 'Complaint' },
    { value: OTHERS, label: 'Others' },
    { value: REQUEST, label: 'Request' },
    { value: ENQUIRY, label: 'Enquiry' },
    { value: MBS, label: 'MBS' },
];
exports.TICKET_CLUSTER_CHOICES = [
    { value: '', label: 'Please select customer cluster' },
    { value: CLUSTER_0, label: 'Cluster 0' },
    { value: CLUSTER_1, label: 'Cluster 1' },
    { value: CLUSTER_2, label: 'Cluster 2' },
    { value: CLUSTER_3, label: 'Cluster 3' },
    { value: CLUSTER_4, label: 'Cluster 4' },
];
exports.TICKET_SOURCE_CHOICES = [
    { value: '', label: 'Please select a source' },
    { value: EMAIL, label: 'Email' },
    { value: PORTAL, label: 'Portal' },
    { value: PHONE, label: 'Phone' },
    { value: FORUM, label: 'Forum' },
    { value: TWITTER, label: 'Twitter' },
    { value: FACEBOOK, label: 'Facebook' },
    { value: CHAT, label: 'Chat' },
    { value: MOBIHELP, label: 'Mobihelp' },
    { value: FEEDBACK_WIDGET, label: 'Feedback Widget' },
    { value: OUTBOUND_EMAIL, label: 'Outbound Email' },
    { value: ECOMMERCE, label: 'Ecommerce' },
    { value: BOT, label: 'Bot' },
    { value: WHATSAPP, label: 'Whatsapp' },
];
exports.PRIORITY_CHOICES = [
    { value: '', label: 'Please select a priority' },
    { value: exports.LOW, label: 'Low' },
    { value: exports.MEDIUM, label: 'Medium' },
    { value: exports.HIGH, label: 'High' },
    { value: exports.URGENT, label: 'Urgent' },
];
exports.PRODUCT_CHOICES = [
    { value: '', label: 'Please select a product' },
    { value: exports.JUMIA, label: 'Jumia' },
    { value: exports.QC, label: 'QC' },
    { value: exports.SAVINGS, label: 'Savings' },
];
exports.OFFICER_TYPES_CHOICES = [
    { value: '', label: "Please select reporter's type" },
    { value: typesConstants_1.OFFICER_TYPES_TELE_COLLECTION, label: 'Tele Collection Officer' },
    { value: typesConstants_1.OFFICER_TYPES_FIELD_RECOVERY, label: 'Field Recovery Officer' },
    { value: typesConstants_1.OFFICER_TYPES_QUALITY_ANALYST, label: 'Quality Analyst' },
    { value: typesConstants_1.OFFICER_TYPES_CUSTOMER_SUPPORT, label: 'Customer Support Representative' },
    { value: typesConstants_1.OFFICER_TYPES_KEY_ACCOUNT, label: 'Key Account Officer' },
    { value: typesConstants_1.OFFICER_TYPES_TELE_COLLECTION_ASSISTANT, label: 'Tele Collection Assistant' },
    { value: typesConstants_1.OFFICER_TYPES_PRE_QUALIFICATION, label: 'Pre-Qualification Officer' },
    { value: typesConstants_1.OFFICER_TYPES_TELE_SALES, label: 'Tele Sales Officer' },
];
exports.TICKET_SUBJECT = [
    { value: '', label: 'Please select ticket subject' },
    { value: 0, label: 'Account Suspension' },
    { value: 1, label: 'Loan extension' },
    { value: 2, label: 'Adding card issue' },
    { value: 3, label: 'App Freezing' },
    { value: 4, label: 'App Issue' },
    { value: 5, label: 'App location error' },
    { value: 6, label: 'App not on Playstore' },
    { value: 7, label: 'Auto Debit complaint' },
    { value: 8, label: 'Auto Debit Request' },
    { value: 9, label: 'Bank Statement' },
    { value: 10, label: 'BVN Validation' },
    { value: 11, label: "Can't make payment via card" },
    { value: 12, label: "Can't make payment via Monnify" },
    { value: 13, label: "Can't make payment via Providus" },
    { value: 14, label: 'Canceled Loans' },
    { value: 15, label: 'Card Linked to other users' },
    { value: 16, label: 'Card removal request' },
    { value: 17, label: 'Credit report' },
    { value: 18, label: 'Converted to 5 Stars' },
    { value: 19, label: 'Credibuilder yellow card' },
    { value: 20, label: 'Death Certificate' },
    { value: 21, label: 'Disbursement complaint' },
    { value: 22, label: 'Disbursement inquiry' },
    { value: 23, label: 'Double debit via Card' },
    { value: 24, label: 'Double debit via Monify' },
    { value: 25, label: 'Double disbursal' },
    { value: 26, label: 'Dropped Call' },
    { value: 27, label: 'High Interests' },
    { value: 28, label: 'IOS compatible' },
    { value: 29, label: 'KYC Needed' },
    { value: 30, label: 'Language Barrier' },
    { value: 31, label: 'Late disbursement' },
    { value: 32, label: 'Loan Complaints' },
    { value: 40, label: 'Loan increment' },
    { value: 41, label: 'Loan Inquiry' },
    { value: 42, label: 'Loan Limit Reduction' },
    { value: 43, label: 'Loan Overpayment' },
    { value: 44, label: 'Loan Payment Complaint flutterwave' },
    { value: 45, label: 'Loan Payment Complaint GTB' },
    { value: 46, label: 'Loan payment complaint Monnify' },
    { value: 47, label: 'Loan payment complaint Paystack' },
    { value: 48, label: 'Loan payment complaint Providus' },
    { value: 49, label: 'Loan rejection' },
    { value: 50, label: 'Loan Status Payment Inquiry' },
    { value: 51, label: 'Loan tenure issue' },
    { value: 52, label: 'Login Issue' },
    { value: 54, label: 'Login Otp failed' },
    { value: 55, label: 'Login Otp not received' },
    { value: 56, label: 'Merged Accounts' },
    { value: 57, label: 'Mismatched Payment' },
    { value: 58, label: 'Negative Remarks' },
    { value: 59, label: 'No ATM Card' },
    { value: 60, label: 'Noisy Call' },
    { value: 61, label: 'Not related to QC' },
    { value: 62, label: 'Others' },
    { value: 64, label: 'Paid defaulted' },
    { value: 65, label: 'Part payment request' },
    { value: 66, label: 'Phone Finance' },
    { value: 67, label: 'Phone Not Compatible' },
    { value: 68, label: 'Pin Reset Issue' },
    { value: 69, label: 'Positive Remarks' },
    { value: 70, label: 'Promised to pay' },
    { value: 71, label: 'Refunds' },
    { value: 72, label: 'Registration Issue' },
    { value: 73, label: 'Repayment enquiry' },
    { value: 74, label: 'Request A/C details GTB/Monnify' },
    { value: 75, label: 'Rude cc or cs' },
    { value: 76, label: 'Saving enquiry' },
    { value: 77, label: 'Saving Issues' },
    { value: 78, label: 'Selfie Issues' },
    { value: 79, label: 'Silent Call' },
    { value: 80, label: 'Stop Interests' },
    { value: 81, label: 'Stuck on preparing loan offer' },
    { value: 82, label: 'User information change' },
    { value: 83, label: 'Card Verification Code Issues' },
    { value: 85, label: 'Wrongful Debit' },
    { value: 86, label: 'Profile deactivation request' },
    { value: 87, label: 'Manual confirmation' },
    { value: 88, label: "Can't make payment via Squadco" },
    { value: 89, label: 'Direct debit' },
    { value: 90, label: 'Fraud case' },
];
exports.TICKET_SUMMARY_KEYS = ['name', 'phone_number', 'email', 'customer_id', 'cluster', 'product'];
exports.TICKET_DESCRIPTION_KEYS = ['subject', 'supplementary_subject', 'description'];
exports.TICKET_ASSIGNED_OFFICER_KEYS = ['assigned_officer'];
// Required Fields
exports.REQUIRED_FIELDS = ['name', 'cluster', 'type', 'source', 'subject', 'description', 'product'];
exports.TICKET_FIELDS = [
    { key: 'name', value: {} },
    { key: 'phone_number', value: {} },
    { key: 'email', value: {} },
    { key: 'subject', value: { choices: exports.TICKET_SUBJECT } },
    { key: 'supplementary_subject', value: {} },
    { key: 'description', value: {} },
    { key: 'priority', value: { choices: exports.PRIORITY_CHOICES, default: exports.LOW } },
    { key: 'product', value: { choices: exports.PRODUCT_CHOICES, default: exports.QC } },
    { key: 'assigned_team', value: { choices: exports.ASSIGNED_TEAM_CHOICES, default: exports.SUPPORT } },
    { key: 'assigned_officer', value: { choices: undefined } },
    { key: 'status', value: { choices: exports.STATUS_CHOICES, default: exports.OPEN } },
    { key: 'type', value: { choices: exports.TICKET_TYPE_CHOICES, default: ENQUIRY } },
    { key: 'source', value: { choices: exports.TICKET_SOURCE_CHOICES, default: PHONE } },
    { key: 'cluster', value: { choices: exports.TICKET_CLUSTER_CHOICES, default: CLUSTER_0 } },
    { key: 'customer_id', value: {} },
];
exports.SUPPORT_CREATE_TICKET_FIELDS = ['phone_number', 'name', 'subject', 'product', 'type', 'status'];
exports.CALL_CENTER_TICKET_ORIGIN = 1;
exports.FRESHDESK_TICKET_ORIGIN = 2;
exports.TICKET_ORIGIN_CHOICES = [
    { value: '', label: 'Select origin' },
    { value: exports.CALL_CENTER_TICKET_ORIGIN, label: 'Call Center' },
    { value: exports.FRESHDESK_TICKET_ORIGIN, label: 'Freshdesk' },
];
exports.ICON_SIZE = 13;
exports.default = 'support/tickets/';
